<template>
  <div class="orders-view">
    <!-- Top bar -->
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>
    <div class="top-spacer"></div>

    <!-- Header -->
    <div class="panel-head">
      <div class="head-left">
        <h3>Maestro de mantenimiento</h3>
      </div>
      <img src="@/assets/filtros.png" alt="filtros" class="head-icon"/>
    </div>

    <!-- Filters -->
    <form class="filters-card" @submit.prevent="queryOrders">
      <div class="row">
        <label for="order_number">Número de orden</label>
        <input id="order_number" type="text" v-model="orderNumber" placeholder="Ej: MT-1024" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Fecha de solicitud</label>
        <input type="date" v-model="startDate" />
        <span class="sep">al</span>
        <input type="date" v-model="endDate" />
      </div>

      <div class="row">
        <label for="unit">Unidad</label>
        <input id="unit" type="text" v-model="unit" placeholder="# Económico" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="sucursal">Sucursal</label>
        <select id="sucursal" v-model="sucursal" class="form-select">
          <option value="" disabled selected>Seleccione</option>
          <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="operator">Operador</label>
        <input id="operator" type="text" v-model="operator" placeholder="Nombre o ID" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="mechanic">Mecánico</label>
        <input id="mechanic" type="text" v-model="mechanic" placeholder="Nombre o ID" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="motive">Motivo del servicio</label>
        <input id="motive" type="text" v-model="motiveOfService" placeholder="Ej: Preventivo" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="severity">Severidad</label>
        <input id="severity" type="text" v-model="repairSeverity" placeholder="Ej: Alta" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Estatus</label>
        <div class="chips">
          <label class="chip">
            <input type="checkbox" v-model="statusPending" />
            <span>Pendiente</span>
          </label>
          <label class="chip">
            <input type="checkbox" v-model="statusAssigned" />
            <span>Asignado</span>
          </label>
          <label class="chip">
            <input type="checkbox" v-model="statusActive" />
            <span>Activo</span>
          </label>
          <label class="chip">
            <input type="checkbox" v-model="statusCompleted" />
            <span>Completado</span>
          </label>
        </div>
      </div>

      <div class="row actions">
        <div class="cell span-4">
          <button type="submit" class="btn-primary">Aplicar filtros</button>
        </div>
      </div>
    </form>

    <!-- Results -->
    <section class="results-card" id="results-section">
      <div v-if="!canViewTable" class="no-access">
        No tienes permisos para ver el listado de órdenes de mantenimiento.
      </div>
      <div class="results-head">
        <h2>Resultados: {{ totalCount }}</h2>
      </div>

      <div v-if="canViewTable" class="table-scroll">
        <table class="table">
          <thead>
            <tr>
              <th @click="toggleSort('order_number')">
                ID
                <span v-if="isSorted('order_number')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('request_time')">
                Solicitud
                <span v-if="isSorted('request_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('scheduled_for')">
                Programada
                <span v-if="isSorted('scheduled_for')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('unit_short_id')">
                Unidad
                <span v-if="isSorted('unit_short_id')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('operator_first_name')">
                Operador
                <span v-if="isSorted('operator_first_name')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('mechanic_first_name')">
                Mecanico
                <span v-if="isSorted('mechanic_first_name')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('workshop')">
                Taller
                <span v-if="isSorted('workshop')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('motive_of_service')">
                Motivo
                <span v-if="isSorted('motive_of_service')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('cause')">
                Causa
                <span v-if="isSorted('cause')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('assignation_start_time')">
                Inicio
                <span v-if="isSorted('assignation_start_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('estimated_end_time')">
                Salida Aprox.
                <span v-if="isSorted('estimated_end_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('status')">
                Estatus
                <span v-if="isSorted('status')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in queriedOrders" :key="order.id" class="row-click" @click="viewMaintenanceOrder(order.id)">
              <td>
                <span class="badge badge-id" @click.stop="viewMaintenanceOrder(order.id)">
                  {{ order.order_number || order.id }}
                </span>
              </td>
              <td>{{ formatDateTime(order.request_time) }}</td>
              <td>{{ formatDateTime(order.scheduled_for) }}</td>
              <td>{{ order.unit_short_id || 'N/A' }}</td>
              <td>{{ order.operator_full_name || order.operator_employee_ident || 'N/A' }}</td>
              <td>{{ order.mechanic_full_name || order.mechanic_employee_ident || 'N/A' }}</td>
              <td>{{ order.workshop || 'N/A' }}</td>
              <td>{{ order.motive_of_service || 'N/A' }}</td>
              <td>{{ order.cause || 'N/A' }}</td>
              <td>{{ formatTime(order.assignation_start_time || order.start_time) }}</td>
              <td>{{ formatTime(order.estimated_end_time) }}</td>
              <td>{{ order.maintenance_status || order.status || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
          <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
        </button>
        <span
          v-for="pageNumber in TotalPages"
          :key="pageNumber"
          @click="goToPage(pageNumber)"
          :class="['pg-num', { active: pageNumber === currentPage }]"
        >
          {{ pageNumber }}
        </span>
        <button @click="nextPage" :disabled="currentPage >= TotalPages" class="pg-btn" aria-label="Página siguiente">
          <img src="@/assets/angulo-derecho.png" alt="Next Page" />
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

const MAINTENANCE_FILTERS_STATE_KEY = 'maintenanceOrderFiltersStateV1'
const MAINTENANCE_FILTERS_RETURN_KEY = 'maintenanceOrderFiltersReturnFromEditV1'

export default {
  name: 'MaintenanceOrderFilters',
  data() {
    return {
      permissions: [],
      orderNumber: '',
      startDate: '',
      endDate: '',
      unit: '',
      sucursal: '',
      operator: '',
      mechanic: '',
      motiveOfService: '',
      repairSeverity: '',
      statusPending: false,
      statusAssigned: false,
      statusActive: false,
      statusCompleted: false,
      queriedOrders: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      sortState: { by: 'request_time', dir: 'desc' },
    }
  },
  computed: {
    canViewTable() {
      return this.hasAnyPerm(['maintenance.view_order_table'])
    },
    canViewOrder() {
      return this.hasAnyPerm(['maintenance.view_order'])
    },
    canAccessOrderMaster() {
      return this.hasAnyPerm(['maintenance.view_order_master'])
    },
    effectiveEndDate() {
      return this.endDate || this.startDate
    },
    TotalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize))
    },
    selectedStatuses() {
      const statuses = []
      if (this.statusPending) statuses.push('Pending')
      if (this.statusAssigned) statuses.push('Assigned')
      if (this.statusActive) statuses.push('Active')
      if (this.statusCompleted) statuses.push('Completed')
      return statuses
    },
  },
  mounted() {
    this.loadPermissions()
    if (!this.canAccessOrderMaster) {
      Swal.fire('Sin acceso', 'No tienes permisos para ver el maestro de mantenimiento.', 'warning')
      this.$router.push({ name: 'MainPanel' })
      return
    }
    this.restoreStateIfReturningFromOrder()
  },
  beforeRouteLeave(to, from, next) {
    if (to?.name === 'EditMaintenanceOrder') {
      this.persistState()
      sessionStorage.setItem(MAINTENANCE_FILTERS_RETURN_KEY, '1')
    } else {
      this.clearPersistedState()
    }
    next()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    backMainPanel() {
      this.clearPersistedState()
      this.$router.push({ path: '/main-panel' })
    },
    viewMaintenanceOrder(orderId) {
      if (!this.canViewOrder) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver la orden.', 'warning')
        return
      }
      this.$router.push({ path: `/maintenance-order/${orderId}` })
    },
    persistState() {
      try {
        const state = {
          orderNumber: this.orderNumber,
          startDate: this.startDate,
          endDate: this.endDate,
          unit: this.unit,
          sucursal: this.sucursal,
          operator: this.operator,
          mechanic: this.mechanic,
          motiveOfService: this.motiveOfService,
          repairSeverity: this.repairSeverity,
          statusPending: this.statusPending,
          statusAssigned: this.statusAssigned,
          statusActive: this.statusActive,
          statusCompleted: this.statusCompleted,
          queriedOrders: this.queriedOrders,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          totalCount: this.totalCount,
          sortState: this.sortState,
        }
        sessionStorage.setItem(MAINTENANCE_FILTERS_STATE_KEY, JSON.stringify(state))
      } catch (error) {
        console.error('Could not persist maintenance filters state', error)
      }
    },
    clearPersistedState() {
      try {
        sessionStorage.removeItem(MAINTENANCE_FILTERS_STATE_KEY)
        sessionStorage.removeItem(MAINTENANCE_FILTERS_RETURN_KEY)
      } catch (error) {
        console.error('Could not clear maintenance filters state', error)
      }
    },
    restoreStateIfReturningFromOrder() {
      try {
        const shouldRestore = sessionStorage.getItem(MAINTENANCE_FILTERS_RETURN_KEY) === '1'
        if (!shouldRestore) {
          this.clearPersistedState()
          return
        }
        const raw = sessionStorage.getItem(MAINTENANCE_FILTERS_STATE_KEY)
        if (!raw) {
          sessionStorage.removeItem(MAINTENANCE_FILTERS_RETURN_KEY)
          return
        }
        const state = JSON.parse(raw)
        if (!state || typeof state !== 'object') {
          sessionStorage.removeItem(MAINTENANCE_FILTERS_RETURN_KEY)
          return
        }
        this.orderNumber = state.orderNumber || ''
        this.startDate = state.startDate || ''
        this.endDate = state.endDate || ''
        this.unit = state.unit || ''
        this.sucursal = state.sucursal || ''
        this.operator = state.operator || ''
        this.mechanic = state.mechanic || ''
        this.motiveOfService = state.motiveOfService || ''
        this.repairSeverity = state.repairSeverity || ''
        this.statusPending = Boolean(state.statusPending)
        this.statusAssigned = Boolean(state.statusAssigned)
        this.statusActive = Boolean(state.statusActive)
        this.statusCompleted = Boolean(state.statusCompleted)
        this.queriedOrders = Array.isArray(state.queriedOrders) ? state.queriedOrders : []
        this.currentPage = Number(state.currentPage) > 0 ? Number(state.currentPage) : 1
        this.pageSize = Number(state.pageSize) > 0 ? Number(state.pageSize) : 20
        this.totalCount = Number(state.totalCount) >= 0 ? Number(state.totalCount) : 0
        this.sortState = state.sortState && state.sortState.by
          ? { by: state.sortState.by, dir: state.sortState.dir === 'asc' ? 'asc' : 'desc' }
          : { by: 'request_time', dir: 'desc' }
        sessionStorage.removeItem(MAINTENANCE_FILTERS_RETURN_KEY)
      } catch (error) {
        console.error('Could not restore maintenance filters state', error)
      }
    },
    formatToDatetime(date, time) {
      return date ? `${date}T${time}` : ''
    },
    formatDateTime(value) {
      if (!value) return 'N/A'
      return `${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)} ${value.substring(11, 16)}`
    },
    formatTime(value) {
      if (!value) return 'N/A'
      return value.substring(11, 16)
    },
    orderingParam() {
      if (!this.sortState?.by) return ''
      const prefix = this.sortState.dir === 'desc' ? '-' : ''
      return `&ordering=${encodeURIComponent(prefix + this.sortState.by)}`
    },
    isSorted(field) {
      return this.sortState.by === field
    },
    toggleSort(field) {
      if (this.sortState.by === field) {
        this.sortState.dir = this.sortState.dir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortState.by = field
        this.sortState.dir = 'asc'
      }
      this.currentPage = 1
      this.queryOrders()
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber
      this.queryOrders()
    },
    nextPage() {
      if (this.currentPage < this.TotalPages) this.currentPage++
      this.queryOrders()
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
      this.queryOrders()
    },
    async queryOrders() {
      if (!this.canViewTable) {
        return
      }
      const payload = {
        order_number: this.orderNumber,
        start_date: this.formatToDatetime(this.startDate, '00:00'),
        end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
        unit_short_id: this.unit,
        sucursal: this.sucursal,
        operator: this.operator,
        mechanic: this.mechanic,
        motive_of_service: this.motiveOfService,
        repair_severity: this.repairSeverity,
        status: this.selectedStatuses,
      }
      const orderingQS = this.orderingParam()
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const url = `${apiDirectory}/get-maintenance-orders-global-filtered?page=${this.currentPage}&page_size=${this.pageSize}${orderingQS}`
        const response = await axios.post(url, payload)
        this.queriedOrders = response.data.results || []
        this.totalCount = response.data.count || 0
        this.persistState()
        this.$nextTick(() => {
          const el = document.getElementById('results-section')
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message
        Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage })
      }
    },
  },
}
</script>

<style scoped>
:root {
  --brand: #ffc434;
  --brand-600: #e6b12e;
  --bg: #f7f7f8;
  --card: #ffffff;
  --border: #e8e8ea;
  --muted: #70737a;
  --text: #1f2328;

  --success: #28a745;
  --assign: #9be15d;
  --danger: #e5484d;
  --pending: #7b61ff;
  --info: #1976d2;
  --neutral: #6e8ba3;

  --radius-sm: 6px;
  --radius-md: 10px;
  --shadow-1: 0 1px 6px rgba(0,0,0,.06);
  --shadow-2: 0 4px 14px rgba(0,0,0,.08);
}

.orders-view {
  background: var(--bg);
  min-height: 100%;
}

.no-access{
  margin: 16px 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f3c7c7;
  background: #fff3f3;
  color: #9b1c1c;
  font-weight: 700;
}

.nav-bar-operations {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 56px;
  background: var(--brand);
  z-index: 1000;
  box-shadow: var(--shadow-1);
}
.logo-button {
  position: absolute; height: 80%;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer; margin: 0;
}
.top-spacer { height: 56px; }

.panel-head {
  margin: 10px 10px 8px;
  padding: 6px 8px;
  display: flex; align-items: center; justify-content: space-between;
}
.panel-head h3 {
  margin: 0;
  font-size: 14px;
  color: var(--text);
  letter-spacing: .2px;
}
.head-icon { width: 22px; height: 22px; opacity: .9; }

.filters-card {
  margin: 0 10px 10px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow-1);
  padding: 8px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  font-size: 12px;
}
.filters-card .row {
  display: grid;
  grid-template-columns: 140px 320px 22px 320px;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.filters-card .row.actions { grid-template-columns: 1fr; margin-top: 2px; }
.filters-card label {
  color: var(--text);
  font-size: 12px;
  white-space: nowrap;
}
.filters-card .sep {
  text-align: center;
  color: var(--muted);
  font-size: 11px;
}
.filters-card input[type="text"],
.filters-card input[type="date"],
.filters-card select {
  height: 26px;
  padding: 0 8px;
  border: 1px solid #d2d2d2;
  border-radius: var(--radius-sm);
  font-size: 12px;
  outline: none;
  background: #fff;
}
.filters-card input::placeholder { color: #9aa0a6; font-size: 11px; }
.filters-card input:focus,
.filters-card select:focus {
  border-color: #bbb;
  box-shadow: 0 0 0 2px rgba(255,196,52,.22);
}

.chips {
  grid-column: 2 / -1;
  display: flex; gap: 6px; flex-wrap: wrap;
}
.chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: #fafafa;
  font-size: 11.5px;
  cursor: pointer;
  user-select: none;
}
.chip input { width: 14px; height: 14px; margin: 0; }
.chip input:checked + span { font-weight: 600; }

.btn-primary {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 8px;
  background: var(--brand);
  border: none; cursor: pointer;
  box-shadow: var(--shadow-1);
}
.btn-primary:hover { background: var(--brand-600); }

.results-card {
  margin: 0 10px 16px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow-1);
  overflow: hidden;
}
.results-head {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
}
.results-head h2 {
  font-size: 14px; margin: 0; color: var(--text);
}

.table-scroll { overflow-x: auto; }
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.15;
}
.table thead th {
  position: sticky; top: 0; z-index: 1;
  background: #f5f6f8;
  color: #475163;
  font-weight: 600;
  border-bottom: 1px solid var(--border);
  padding: 6px 8px;
  white-space: nowrap;
  cursor: pointer;
}
.table tbody td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.table tbody tr:nth-child(even) td { background: #fcfcfd; }
.table tbody tr:hover td { background: #eef3ff; color: #0f172a; }
.row-click { cursor: pointer; }

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  font-size: 11px;
  line-height: 1.3;
  border: 1px solid transparent;
}
.badge-id {
  background: var(--brand);
  color: #000;
  font-weight: 700;
  border: 1px solid #f0c35a;
}

.pagination {
  display: flex; flex-wrap: wrap;
  justify-content: center; align-items: center;
  gap: 6px; padding: 10px;
  border-top: 1px solid var(--border);
}
.pg-btn {
  background: #fff; border: 1px solid var(--border);
  border-radius: 8px; padding: 2px 6px;
  cursor: pointer; box-shadow: var(--shadow-1);
}
.pg-btn:disabled { opacity: .5; cursor: not-allowed; }
.pg-btn img { width: 18px; height: auto; display: block; }
.pg-num {
  min-width: 28px; text-align: center;
  padding: 4px 8px; border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff; cursor: pointer;
  user-select: none;
}
.pg-num.active {
  background: var(--brand);
  border-color: #e0b12b;
}

@media (max-width: 1200px) {
  .filters-card .row {
    grid-template-columns: 120px minmax(180px,1fr) 18px minmax(180px,1fr);
  }
}
@media (max-width: 900px) {
  .filters-card .row { grid-template-columns: 120px 1fr; }
  .filters-card .sep, .filters-card .row > .cell { display: none; }
}
</style>
